import React from 'react';
import { Navigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import AdminLayout from './AdminLayout';
import AdminDashboard from './AdminDashboard';
import type { AdminPermission } from '../../types';

/** Prima sezione utile per ciascun potere — usata per reindirizzare un
 * Team Amministrativo (richiesta utente 25/02/2026) fuori dalla Dashboard
 * globale (riservata al vero admin, mostra KPI su tutto il business). */
const FIRST_PATH_FOR_PERMISSION: Record<AdminPermission, string> = {
  contenuti: '/admin/homepage-prodotti',
  catalogo: '/admin/prodotti',
  resi_ordini: '/admin/ordini',
  clienti: '/admin/clienti',
  abbinatore: '/admin/abbinatore-v2',
  segnalazioni: '/admin/difformita',
  sistema: '/admin/sync-erp',
  carriere: '/admin/carriere',
};

/** Renderizzato su ``/admin``: il vero admin vede la Dashboard globale,
 * un admin_operatore viene reindirizzato automaticamente alla prima
 * sezione per cui ha un potere assegnato (mai la Dashboard, che mostra
 * KPI aggregati su tutto il business). */
export default function AdminHome() {
  const { user } = useAuth();

  if (user?.ruolo === 'admin_operatore') {
    const firstPermission = (user.permessiAdmin || [])[0];
    if (firstPermission && FIRST_PATH_FOR_PERMISSION[firstPermission]) {
      return <Navigate to={FIRST_PATH_FOR_PERMISSION[firstPermission]} replace />;
    }
    return (
      <AdminLayout>
        <div className="flex flex-col items-center justify-center py-24 text-center gap-3" data-testid="admin-no-permessi">
          <ShieldAlert className="w-10 h-10 text-muted-foreground" />
          <p className="font-medium">Nessun potere assegnato al tuo account</p>
          <p className="text-sm text-muted-foreground max-w-sm">Contatta l'amministratore per farti assegnare l'accesso a una o più sezioni del pannello.</p>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <AdminDashboard />
    </AdminLayout>
  );
}
